import { render } from "./OrgApplicationsPage.vue?vue&type=template&id=3bf7bdb6"
import script from "./OrgApplicationsPage.vue?vue&type=script&lang=js"
export * from "./OrgApplicationsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__